import { PowerSocketEuIcon } from './PowerSocketEuIcon';

/**
 * author: GreenTurtwig
 * id 07F4FD1C-A171-4088-BE30-53758CFF45E5
 * name power-socket-eu
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-socket-eu.svg
 * tags
 * - Home Automation 
 */
export const PowerSocketEuropeIcon = PowerSocketEuIcon;
export default PowerSocketEuropeIcon